export const CUSTODIAN_INVITE_CODE_KEY = "CustodianInvite";
export const SIGN_UP_PREFERENCE_KEY = "SignUpPreference";
export const SIGN_UP_APP_VIEW_ROLE_KEY = "SignUpRole";
export const REDIRECT_LOCATION_KEY = "REDIRECT_LOCATION";
export const REFERRAL_KEY = "ReferralCode";
